import React from 'react';
import { createRoot } from 'react-dom/client';
import styles from './index.module.css';
import SongLabels from './SongLabels';

const TOKEN = process.env.REACT_APP_HYMNS_PICKER_TOKEN

class Index extends React.Component {
    //构造函数
    constructor(props) {
        super(props);
        //react定义数据
        this.state = {
            token:""
        }
    }
    componentDidMount() {
    }
    render() {
        return (
            <div><MyProvider>
                <div>
                    <table className={styles.tbl}>
                        <tbody>
                        <tr>
                            <td className={styles.caption}>
                                TLBC 三分钟选歌 <font size = "4">(v0.7.0)</font>
                            </td>
                        </tr>
                        <tr>
                            <td className={styles.tdLabels} colSpan="3">
                                <SongLabels token={TOKEN} />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </MyProvider></div>
        );
    }
}
const root = createRoot(document.getElementById("root"));
root.render(<Index />);

export const MContext = React.createContext(null);
class MyProvider extends React.Component {
    state = {message: ""}
    render() {
        return (
            <MContext.Provider value={
                {
                    state: this.state,
                    setAudio: (url) =>
                        this.setState(
                            {
                                audioUrl: url
                            }
                        ),
                    setImage: (resized, original, txt) =>
                        this.setState(
                            {
                                resizedUrl: resized,
                                originalUrl: original,
                                alt: txt
                            }
                        )
                }
            }>
                {this.props.children}
            </MContext.Provider>)
    }
}
